import clsx from "clsx";
import React from "react";
import { Margins, MediaSpecific, marginsClassMS } from "../Layout";
import styles from "./container.module.scss";

interface ColumnProps extends React.ComponentProps<"div">
{
    margins?: MediaSpecific<Margins> | undefined;
}

export const Column = ({ className, margins, ...props }: ColumnProps): React.ReactComponentElement<"div", ColumnProps> =>
{
    const classes = clsx(
        styles["column"],
        marginsClassMS(margins),
        className
    );

    return <div {...props} className={classes} />;
}